// import { MemoryRouter as Router, Routes, Route } from 'react-router-dom';
import ConfigProvider from '@/renderer/components/common/ConfigProvider';
import { RouterProvider } from 'react-router-dom';
import { App as AntdApp } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import router from './routes';
import './App.css';
import 'tailwindcss/tailwind.css';

// 创建一个 client
const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider>
        <AntdApp>
          <RouterProvider router={router} />
        </AntdApp>
      </ConfigProvider>
    </QueryClientProvider>
  );
}
